import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { RejectRewardTicketValidationSchema } from '../schemas/rejectRewardTicket.schema'

interface UseRejectRewardTicketProps {
  id?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useRejectRewardTicket = ({ id, onSuccess, onError }: UseRejectRewardTicketProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['rejectRewardTicket', id],
    mutationFn: async (form: RejectRewardTicketValidationSchema) => {

      const reward_ticket = {
        reject_reason: form?.reject_reason,
      }

      return privateAxios.put(`/tmais/reward_tickets/${id}/reject`, { reward_ticket })
    },
    onSuccess,
    onError,
  })
}
